define('components/course/collections/slides',[
    'components/course/collections/base',
    'components/course/models/slide'
], function (BaseCollection, Slide) {
    "use strict";

    return BaseCollection.extend({
        "model": Slide,

        "getActiveSlide": function () {
            return this.findWhere({"isActive": true}) || null;
        },

        "getActiveSlideIndex": function () {
            return this.indexOf(this.getActiveSlide());
        },

        "isComplete": function () {
            var completedSlides = this.where({
                    "isComplete": true
                });

            return completedSlides.length === this.length;
        }
    });
});

